import { IconCheck, IconX } from '@tabler/icons-react'

import { PASSWORD_RULES } from 'shared/utils/validators'

import styles from './PasswordHint.module.scss'

interface TestOptionProps {
  valid: boolean
  label: string
}

interface PasswordHintProps {
  password: string
}

const TestOption = ({ valid, label }: TestOptionProps) => {
  return (
    <div className={styles.option}>
      <div className={styles.mark} aria-hidden='true'>
        {valid ? (
          <IconCheck className={styles.checkIcon} />
        ) : (
          <IconX className={styles.errorIcon} />
        )}
      </div>
      <div className={styles.label}>
        {label}
        <span className='visually-hidden'>
          {valid ? ' – spełnione' : ' – niespełnione'}
        </span>
      </div>
    </div>
  )
}

const PasswordHint = ({ password = '' }: PasswordHintProps) => {
  return (
    <div className={styles.wrapper}>
      {PASSWORD_RULES.map(({ key, label, pattern }) => (
        <TestOption key={key} valid={pattern.test(password)} label={label} />
      ))}
    </div>
  )
}

export default PasswordHint
